import { render } from "./Links.vue?vue&type=template&id=59f9f661"
const script = {}

import exportComponent from "C:\\Users\\moritz.kretschmer\\Documents\\hiddenstorm\\hiddenstorm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__